import { render, staticRenderFns } from "./Cadena.vue?vue&type=template&id=42b8f685&scoped=true&"
import script from "./Cadena.vue?vue&type=script&lang=js&"
export * from "./Cadena.vue?vue&type=script&lang=js&"
import style0 from "./Cadena.vue?vue&type=style&index=0&id=42b8f685&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8f685",
  null
  
)

export default component.exports